import { InfoCard } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';
import { Grid, Typography } from '@material-ui/core';

const annotationKeys = {
  accountId: 'aws.amazon.com/account-id',
  accountUrl: 'aws.amazon.com/account-url',
  region: 'aws.amazon.com/region',
  resourceType: 'aws.amazon.com/resource-type',
  resourceArn: 'aws.amazon.com/arn',
  consoleUrl: 'aws.amazon.com/console-url',
  logsUrl: 'aws.amazon.com/logs-url',
};

export const EntityAwsCard = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const getAnnotation = (key: keyof typeof annotationKeys) =>
    annotations[annotationKeys[key]];
  const accountId = getAnnotation('accountId');
  const accountUrl = getAnnotation('accountUrl');
  const region = getAnnotation('region');
  const resourceType = getAnnotation('resourceType');
  const resourceArn = getAnnotation('resourceArn');
  const consoleUrl = getAnnotation('consoleUrl');
  const logsUrl = getAnnotation('logsUrl');
  const hasAwsMetadata = Boolean(
    accountId || accountUrl || region || resourceType || resourceArn || consoleUrl || logsUrl,
  );

  return (
    <InfoCard title="AWS">
      {!hasAwsMetadata ? (
        <Typography color="textSecondary">
          Add AWS annotations to this entity to show its account, region, resource, and operational links.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {accountId && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Account
              </Typography>
              {accountUrl ? (
                <a href={accountUrl} target="_blank" rel="noreferrer">
                  {accountId ?? 'AWS account'}
                </a>
              ) : (
                <Typography>{accountId}</Typography>
              )}
            </Grid>
          )}
          {region && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Region
              </Typography>
              <Typography>{region}</Typography>
            </Grid>
          )}
          {resourceType && (
            <Grid item xs={12} sm={6}>
              <Typography variant="caption" color="textSecondary" display="block">
                Resource type
              </Typography>
              <Typography>{resourceType}</Typography>
            </Grid>
          )}
          {resourceArn && (
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary" display="block">
                ARN
              </Typography>
              <Typography style={{ overflowWrap: 'anywhere' }}>{resourceArn}</Typography>
            </Grid>
          )}
          {(consoleUrl || logsUrl) && (
            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary" display="block">
                AWS links
              </Typography>
              {consoleUrl && (
                <Typography component="div">
                  <a href={consoleUrl} target="_blank" rel="noreferrer">
                    AWS Console
                  </a>
                </Typography>
              )}
              {logsUrl && (
                <Typography component="div">
                  <a href={logsUrl} target="_blank" rel="noreferrer">
                    CloudWatch Logs
                  </a>
                </Typography>
              )}
            </Grid>
          )}
        </Grid>
      )}
    </InfoCard>
  );
};
